import SwitchBig from './SwitchBig.vue';

SwitchBig.install = (Vue) => {
  Vue.component(SwitchBig.name, SwitchBig);
};

export default SwitchBig;
